import cn from '../../../lib/classNames';

import avatar from './images/avatar.png';

import styles from './EquipYourPeople.module.scss';

type EquipYourPeopleType = {
	classPageContent?: string;
};

export default function EquipYourPeople(props: EquipYourPeopleType) {
	const { classPageContent } = props;
	return (
		<div className={styles.wrap}>
			<div className={cn(styles.content, classPageContent)}>
				<div className={styles.title}>
					Equip your people with tailored assessments of health, safety, and security hazards at
					home and abroad
				</div>
				<div className={styles.details}>
					<div className={styles.avatar}>
						<img src={avatar} alt="Filippo Marrino" />
					</div>
					<div className={styles.description}>Filippo Marino, Safe-esteem CEO</div>
				</div>
			</div>
		</div>
	);
}
